<p>
    The one-way ANOVA test is a parametric test that tests the hypothesis that the mean of
    <b>{{ params.xColumn.name }}</b>
    is identical in all populations.
</p>

<p>
    <list-compared-populations [params]="params"></list-compared-populations>
</p>

<p>
    There are two possible outcomes depending on the 𝘱-value:
</p>

<ul>
    <li>
        <b>
            𝘱-value &le; significance level (&le; {{ 1 - params.confidenceLevel | smarterNumber }})
        </b>
        <br>
        The hypothesis is rejected. The population mean of
        <b>{{ params.xColumn.name }}</b>
        is not the same in all the populations.
    </li>
    <li>
        <b>
            𝘱-value is &gt; significance level (&gt; {{ 1 - params.confidenceLevel | smarterNumber }})
        </b>

        <br>
        Not enough evidence against the hypothesis. Test is inconclusive.
    </li>
</ul>

<p>
    It has been shown that the conclusion is meaningful under the following conditions:
</p>
<ul>
    <li>
        Observations of
        <b>{{ params.xColumn.name }}</b>
        are independent and identically distributed
    </li>
    <li>
        Variable
        <b>{{ params.xColumn.name }}</b>
        is normally distributed in every population
        <br>
        <span
            class="text-weak"
            *ngIf="canAddCard"
        >
            <i class="icon-lightbulb"></i>
            You may want to check this assumption using a
            <a (click)="addGroupedShapiro()">Shapiro-Wilk test</a>
        </span>
    </li>
    <li>
        Variance of
        <b>{{ params.xColumn.name }}</b>
        is identical in all populations
        <br>
        <span
            class="text-weak"
            *ngIf="canAddCard"
        >
            <i class="icon-lightbulb"></i>
            You may want to have a look at
            <a (click)="addGroupedSummary()">summary statistics</a>
        </span>
    </li>
</ul>

<p>
    <span class="text-weak">
        <i class="icon-info-sign"></i>
        Missing values are discarded
    </span>
</p>
